export const PlusCircleIcon = ({ color = "#4E4E4E", size = 20, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <line x1="16.7988" y1="10.8301" x2="4.19883" y2="10.8301" stroke={color} stroke-width="1.5" />
        <line x1="10.1699" y1="16.7998" x2="10.1699" y2="4.19981" stroke={color} stroke-width="1.5" />
        <circle cx="10.5" cy="10.5" r="9.75" transform="rotate(90 10.5 10.5)" stroke={color} stroke-width="1.5" />
    </svg>

);